module.exports = __webpack_public_path__ + "img/live.042be9b9.png";